<template>
  <b-tab title="Atividades" class="m-0 p-0">
    <div class="tab-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE ATIVIDADES DAS EQUIPES :::::::::::::::::::::::::::: -->
      <b-table bordered hover small head-variant="light" :items="getFilterAtividades(filtro)" :fields="fields.atividade">
        <template #cell(data)="data">
          <div>
            <p class="pt-0 pb-0">
              {{ moment(data.item.data).format("DD/MM/YYYY") }}
            </p>
          </div>
        </template>

        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)" v-b-tooltip.hover title="Editar">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="trabalhos(data.item)" v-b-tooltip.hover title="Trabalhos">
              <b-icon icon="wrench" variant="info"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="deletar(data.item)" v-b-tooltip.hover title="Deletar">
              <b-icon icon="trash-fill" variant="danger"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: BARRA DE AÇÕES :::::::::::::::::::::::::::: -->
    <div class="menu-acoes pb-2">
      <div id="search-bar">
        <b-col cols="12" class="p-1 pr-0">
          <b-form inline>
            <b-button size="sm" class="pl-2 pr-3" variant="info" @click="adicionar()">
              <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
            </b-button>
            <b-form-input
              id="atv-desc-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Descrição"
              v-model="filtro.descricao"
            />
            <b-form-input
              id="atv-cliente-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Cliente"
              v-model="filtro.cliente"
            />
            <b-form-input
              id="atv-grupo-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Grupo"
              v-model="filtro.grupo"
            />
            <b-form-input
              id="atv-resp-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Responsável"
              v-model="filtro.codigo"
            />
            <b-icon icon="search" variant="light" scale="1.2" class="m-1" />
            <b-button size="sm" class="m-1 ml-3" variant="light">
              {{ listas + " listas" }}
            </b-button>
          </b-form>
        </b-col>
      </div>
      <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
      <atividade-modal ref="editorAtividade" />
      <confirm-modal ref="confirmDelAtividade" :descricao="'Deseja realmente remover a atividade ?'" @executar="executar()" />
      <trabalho-list-modal ref="trabalhoList" />
    </div>
  </b-tab>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useAtividadeStore } from "@/stores/AtividadeStore";
import Atividade from "@/models/Atividade";
import TableFields from "@/tools/TableFields";
import AtividadeModal from "@/components/modals/atividade/AtividadeModal";
import TrabalhoListModal from "@/components/modals/atividade/TrabalhoListModal";
import ConfirmModal from "@/components/modals/diversos/ConfirmModal.vue";
import Notificacao from "@/models/Notificacao";

export default {
  name: "AtividadeTabList",

  data() {
    return {
      fields: new TableFields(),
      filtro: {
        descricao: "",
        grupo: "",
        responsavel: "",
        cliente: "",
      },
      atividade: new Atividade(0, "Nova Atividade", "", new Date(), "", ""),
    };
  },

  components: {
    "atividade-modal": AtividadeModal,
    "confirm-modal": ConfirmModal,
    "trabalho-list-modal": TrabalhoListModal,
  },

  computed: {
    listas() {
      return this.getFilterAtividades(this.filtro).length;
    },
  },

  methods: {
    adicionar() {
      this.atividade = new Atividade(0, "Nova Atividade", "", new Date(), "", "");
      this.$refs.editorAtividade.call(this.atividade);
    },

    editar(atividade) {
      this.$refs.editorAtividade.call(atividade);
    },

    trabalhos(atividade) {
      this.$refs.trabalhoList.call(atividade);
    },

    deletar(atividade) {
      this.atividade.update(atividade);
      this.$refs.confirmDelAtividade.call();
    },

    executar() {
      this.atividadeStore.LISTAR_TRABALHOS(this.atividade.id).then(() => {
        if (this.getTrabalhos.length === 0) {
          this.atividadeStore.REMOVER_ATIVIDADE(this.atividade.id);
        } else {
          this.store.NOTIFICAR(new Notificacao("Existem trabalhos não executados na atividade!", "Não Executado!", "danger"));
        }
      });
    },
  },

  setup() {
    const store = useSgcqStore();
    const atividadeStore = useAtividadeStore();
    const { getTrabalhos } = storeToRefs(atividadeStore);
    const { getFilterAtividades } = storeToRefs(atividadeStore);

    return {
      store,
      atividadeStore,
      getFilterAtividades,
      getTrabalhos,
    };
  },
};
</script>

<style lang="scss" scoped>
#atv-desc-filter {
  width: 20rem;
}
#atv-cliente-filter {
  width: 15rem;
}
#atv-grupo-filter {
  width: 10rem;
}
#atv-resp-filter {
  width: 10rem;
}
.menu-acoes {
  background-color: #112a4a;
}
</style>
